import type { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { MealStatus } from '../enums/MealStatus'

export class MealMiniEntity {
  id?: string
  company?: {
    id?: number
    name?: string
    location?: LngLatEntity
  }
  service?: {
    id?: number
    name?: string
  }
  startAt?: string
  lockAt?: string
  status?: MealStatus
  statusUpdatedAt?: string
  companyPeriodTime?: string
  referenceCode?: string
  trackingPanelUserId?: string | null
  trackingPanelUserDisplayName?: string | null
}
